import { useAppSelector } from '../redux';

const useHoveredAdminResult = () => {
  const { hoveredAdminResult } = useAppSelector(state => ({
    hoveredAdminResult: state.map.hoveredAdminResult
  }));

  return hoveredAdminResult;
};

export default useHoveredAdminResult;
